module.exports = __webpack_public_path__ + "static/media/2_3.a450069d.png";